import { render, staticRenderFns } from "./luckDraw.vue?vue&type=template&id=c6ca4936&scoped=true&"
import script from "./luckDraw.vue?vue&type=script&lang=js&"
export * from "./luckDraw.vue?vue&type=script&lang=js&"
import style0 from "./luckDraw.vue?vue&type=style&index=0&id=c6ca4936&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ca4936",
  null
  
)

export default component.exports